import { DEFAULT_LOGO } from '@/utils/constant/image'

const Fallback = () => {
  return (
    <div className="flex h-screen animate-pulse flex-col items-center justify-center">
      <img className="h-28 w-28 rounded-full object-cover object-center" src={DEFAULT_LOGO} alt="Skoolib logo" />
    </div>
  )
}

export default Fallback
